// Mirrors apps/backend/core/models.py::Classroom.SEMESTER_CHOICES.
// Keep this list in sync manually for now (per .claude/rules/dry-principles.md §5).
export const SEMESTER_CHOICES = ["2024-2025", "2025-2026", "2026-2027"] as const
export type Semester = (typeof SEMESTER_CHOICES)[number]
